import React from 'react';

const LandscapeProductCardPlaceholder = () => {
  return (
    <div className="bg-white flex items-center border solid border-gray-200 rounded p-3 mb-1 gap-3">
      <div className="h-20 w-20 bg-gray-200 skeleton"></div>
      <div className="flex flex-col flex-1 gap-1.5">
        <div className={`bg-gray-200 rounded-0.5 h-4 max-w-[56%]`}>&nbsp;</div>
        <div className={`bg-gray-200 rounded-0.5 h-4 max-w-[48%]`}>&nbsp;</div>
        <div className={`bg-gray-200 rounded-0.5 max-w-[80px]`}>&nbsp;</div>
        <div className={`bg-gray-200 rounded-0.5 max-w-[32px]`}>&nbsp;</div>
        <div className={`bg-gray-200 rounded-0.5 max-w-[56px]`}>&nbsp;</div>
      </div>
      <div className="btn--medium skeleton bg-gray-200 w-24">&nbsp;</div>
    </div>
  );
};

export default LandscapeProductCardPlaceholder;
